import React from 'react';
import { PdsErrorPage } from "@principal/design-system-react";

const Unauthorized = () => (
    <PdsErrorPage errorCode="403" linkHref={process.env.REACT_APP_ENTERPRISE_MEMBER_URL as string} linkText="Head back to the homepage"/>
)
export default Unauthorized;
